module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.04134b4e.png";